import React, { useEffect } from "react";
import Author from "components/common/author";
import { FormGroup, FormInput, Badge, Alert, Row, Card, CardBody } from "../../components/ui";
import PlansCards from "components/common/PlansCards";
import { Link } from "react-router-dom";

const PostData = ({
  post,
  user,
  showShare,
  οnShare,
  removeAsFavorite,
  setAsFavourite,
  likePost,
  shareRef,
  publicAccessVerified,
  publicAccessError,
  checkPublicAccessConfirmed,
  subscribeToPublic,
  publicAccessName,
  publicAccessEmail,
  isPublicAccessClass,
  isPreview,
  onPublicNameInput = () => undefined,
  onPublicEmailInput = () => undefined,
}) => {
  const publisher = (post && post.author) || {};
  useEffect(() => {
    setTimeout(() => {
      if (post && post.embeddedVideo && isPreview) {
        const videoPlayer = window.Wistia.api("7twlrlom1r");
        if (videoPlayer) {
          videoPlayer.addToPlaylist(post.embeddedVideo.mediaId);
        }
      }
    }, 1000);
  }, []);

  const content =
    post &&
    post.content &&
    post.content.replace(`data-jodit_iframe_wrapper="1"`, "");

  return (
    <div>
      <div className="post-data">
        <img src={post && post.image && post.image.original} alt="post" />
        <br />
        <div className="post-header">
          <h4>{post && post.title}</h4>
          <div
            style={{
              lineHeight: "36px",
              marginLeft: window.screen.width > 1140 ? "3%" : {},
            }}
            className="badges"
          >
            <Badge pill className={`card-post__category badge-content-type`}>
              {post && post.contentTypeId === 1 ? "Blog" : "Video"}
            </Badge>
            {post &&
              post.tags &&
              post.tags.slice(0, 4).map((tag, idx) => (
                <Badge pill className={`card-post__category badge-content-tag`}>
                  {tag.name}
                </Badge>
              ))}
            {post &&
              post.educationTopics &&
              post.educationTopics.map((educationalTopics, idx) => (
                <Badge
                  pill
                  className={`card-post__category badge-content-education`}
                >
                  {educationalTopics.name}
                </Badge>
              ))}
          </div>
        </div>

        <div className="card-post__author d-flex author-data">
          <Author
            url={`/analyst/${publisher.slug}`}
            name={publisher.name}
            avatar={publisher && publisher.avatar && publisher.avatar.small}
            date={post && post.publishedAt}
            badges={["Analyst"]}
            badgeImg={require("../../images/bitcoin-live/verified.png")}
            badgeImgClass={"publisher-badge-img"}
            nameStyle={{
              fontWeight: "bold",
              fontSize: "14px",
              textShadow:
                "0 1px 4px rgba(255,255,255,0.3), 0 1px 4px rgba(0,0,0,0.15)",
            }}
          />
          <div className="social">
            <span className="add-favorite">
              {user && (
                <div className="link-social">
                  <div
                    class="rating"
                    style={{ position: "relative", top: "-4px" }}
                  >
                    {post.isFavourite ? (
                      <span className="selected" onClick={removeAsFavorite}>
                        ★
                      </span>
                    ) : (
                      <span onClick={setAsFavourite}>☆</span>
                    )}
                    Favorite
                  </div>
                </div>
              )}
              {user && (
                <div className="link-social">
                  <i
                    className={
                      post && post.likes.likedByCurrentUser
                        ? "material-icons thumb_up selected"
                        : "material-icons thumb_up"
                    }
                    onClick={likePost}
                  >
                    thumb_up
                  </i>
                  {post && post.likes.total} Likes
                </div>
              )}
              {post && post && post.contentAvailabilityId !== 2 && (
                <div className="link-social">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      "http://twitter.com/share?url=" +
                      encodeURIComponent(
                        window.location.origin +
                          post.url +
                          "?aid=" +
                          publisher.slug
                      ) +
                      "&text=New premium (member) post by " +
                      publisher.name +
                      " was published on bitcoin.live."
                    }
                  >
                    <i
                      className="fab fa-twitter-square"
                      style={{ color: "#1DA1F2" }}
                    ></i>
                  </a>
                </div>
              )}
              {post && post.contentAvailabilityId !== 2 && (
                <div className="link-social">
                  <a
                    href={
                      "https://www.facebook.com/sharer/sharer.php?u=" +
                      window.location.origin +
                      post.url +
                      "?aid=" +
                      publisher.slug
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i
                      className="fab fa-facebook-square"
                      style={{ color: "#3B5998" }}
                    ></i>
                  </a>
                </div>
              )}
              <div className="link-social dropdown-share" onClick={οnShare}>
                <i className="material-icons share">share</i>
                Share
                <div
                  style={{
                    display: !showShare ? "none" : "block",
                    left: !alert.showShare ? "-150px" : "0px",
                  }}
                  className={
                    !showShare
                      ? "dropdown-content"
                      : "dropdown-content show-share"
                  }
                  ref={shareRef}
                >
                  {post && (
                    <FormGroup className="form-group">
                      <label htmlFor="feCurrPass">URL:</label>
                      <FormInput
                        id="feNewPass"
                        type="text"
                        value={
                          window.location.origin +
                          post.url +
                          "?aid=" +
                          publisher.affiliateId
                        }
                      />
                    </FormGroup>
                  )}
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
      {!user &&
        post &&
        ((post.contentTypeId === 1 && post.content === undefined) ||
          (post.contentTypeId === 2 && post.embeddedVideo === undefined)) && (
          <React.Fragment>
            <CardBody
              className={""}
              dangerouslySetInnerHTML={{ __html: post && post.excerpt }}
            ></CardBody>
            <br />
            <br />
            <Row className="justify-content-center">
              <h4>
                <b>This Content Is For Premium Members Only</b>
              </h4>
            </Row>
            <br />
            <Row
              className="justify-content-center"
              style={{ alignItems: "center" }}
            >
              Already a member?{" "}
              <Link
                to={"/login"}
                className="btn btn-primary"
                style={{ marginLeft: "10px" }}
              >
                {" "}
                Login
              </Link>
            </Row>
            <br />
            <Row className="justify-content-center">
              <h4>
                <b>
                  <u>Membership Options</u>
                </b>
              </h4>
            </Row>
            <PlansCards bg={"#f1f1f1"} paddingTop={"50px"} />
          </React.Fragment>
        )}
      {user &&
        post &&
        ((post.contentTypeId === 1 && post.content === undefined) ||
          (post.contentTypeId === 2 && post.embeddedVideo === undefined)) && (
          <React.Fragment>
            <CardBody
              className={""}
              dangerouslySetInnerHTML={{ __html: post && post.excerpt }}
            ></CardBody>
            <br />
            <br />
            <div className="alerts-premium">
              Please renew your membership to be able to continue reading.
            </div>
            <Link to={"/user-profile"} className="alerts-premium-linear">
              My Billing Area
            </Link>
            <br />
            <br />
          </React.Fragment>
        )}
      {user && post && post.embeddedVideo && post.contentTypeId === 2 && (
        <div
          id="wistia_player"
          className={"wistia_embed wistia_async_7twlrlom1r"}
        ></div>
      )}
      {!user &&
        post &&
        post.embeddedVideo &&
        post.contentTypeId === 2 &&
        post.contentAvailabilityId === 1 && (
          <div
            id="wistia_player"
            className={`wistia_embed wistia_async_7twlrlom1r ${isPublicAccessClass()}`}
          ></div>
        )}
      {post &&
        post.content !== undefined &&
        post.contentAvailabilityId === 1 && (
          <CardBody
            className={isPublicAccessClass() + " post-content"}
            dangerouslySetInnerHTML={{
              __html: post && post.content && content,
            }}
          ></CardBody>
        )}
      {user && post && post.content !== undefined && (
        <CardBody
          className="post-content"
          dangerouslySetInnerHTML={{ __html: post && post.content && content }}
        ></CardBody>
      )}
      {post &&
        !user &&
        (publicAccessVerified === null || publicAccessVerified === false) &&
        post.content !== undefined && (
          <Row md={6} className="justify-content-center">
            <Card
              small
              style={{
                backgroundColor: "#f1f1f1",
                boxShadow: "none",
                maxHeight: window.screen.width < 500 ? 550 : 500,
                width: window.screen.width < 500 ? "100%" : "52%",
                paddingTop: 50,
                paddingBottom: 200,
                marginTop: 150,
                marginBottom: 150,
              }}
            >
              {publicAccessVerified === null && (
                <>
                  <div
                    style={{
                      paddingLeft: 24,
                      paddingRight: 24,
                      textAlign: "center",
                      flexGrow: 1,
                    }}
                  >
                    <h4>
                      <b>Free Content Sign Up</b>
                    </h4>
                    <br />
                    Please provide your email below to access this article and
                    all Bitcoin Live free content. We’ll send you an email and
                    once you verify your email address, the content will be
                    unlocked.
                    <br />
                    <br />
                    If you’ve already verified your email address, simply type
                    it into the form to unlock the content.
                    <br />
                    <br />
                    <FormGroup className="form-group">
                      <FormInput
                        id="feCurrPass"
                        type="text"
                        placeholder="Name"
                        value={publicAccessName}
                        onChange={onPublicNameInput}
                      />
                    </FormGroup>
                    <FormGroup className="form-group">
                      <FormInput
                        id="feCurrPass"
                        type="email"
                        placeholder="Email"
                        value={publicAccessEmail}
                        onChange={onPublicEmailInput}
                      />
                    </FormGroup>
                  </div>
                  <Link
                    to={"#"}
                    className="alerts-premium-linear"
                    onClick={subscribeToPublic}
                    style={{ width: "auto", margin: "20px 25px 0px 25px" }}
                  >
                    Get Access
                  </Link>
                </>
              )}
              {publicAccessVerified === false && (
                <div
                  style={{
                    paddingLeft: 24,
                    paddingRight: 24,
                    textAlign: "center",
                    flexGrow: 1,
                  }}
                >
                  As soon as your email is confirmed click below to refresh the
                  site and get access.
                  <br />
                  <br />
                  <Link
                    to={"#"}
                    className="alerts-premium-linear"
                    onClick={checkPublicAccessConfirmed}
                  >
                    Refresh
                  </Link>
                </div>
              )}
              {publicAccessError && (
                <>
                  <br />
                  <Alert className="mb-0">
                    <i className="fa fa-error mx-2"></i>
                    {publicAccessError}
                  </Alert>
                </>
              )}
            </Card>
          </Row>
        )}
    </div>
  );
};

export default PostData;
